/* eslint-disable no-negated-condition */
import cloneDeep from "lodash.clonedeep";
import { CREATE_QUOTE_REQUESTED, CREATE_QUOTE_PENDING, CREATE_QUOTE_FAILURE, CREATE_QUOTE_SUCCESS,
  FETCH_QUOTE_REQUESTED, FETCH_QUOTE_FAILURE, FETCH_QUOTE_SUCCESS,
  FETCH_SINGLE_QUOTE_BY_ID_REQUESTED, FETCH_SINGLE_QUOTE_BY_ID_FAILURE, FETCH_SINGLE_QUOTE_BY_ID_SUCCESS,
  UPDATE_QUOTE_REQUESTED, UPDATE_QUOTE_FAILURE, UPDATE_QUOTE_SUCCESS, FETCH_QUOTE_BY_USER_ID_REQUESTED,
  FETCH_QUOTE_BY_USER_ID_FAILURE, FETCH_QUOTE_BY_USER_ID_SUCCESS, UPDATE_QUOTE_PENDING } from "../actions/quote-action-types";

const initialState = {
  quotes: [],
  createQuoteStatus: "pending",
  fetchQuotesStatus: "pending",
  fetchQuoteByIdStatus: "pending",
  updateQuoteStatus: "pending",
  userQuotes: [],
  fetchQuoteByUserIdStatus: "pending",
};

export default function quotes(state = initialState, {
  payload, type,
}) {
  const newPayload = [];

  switch (type) {
    case CREATE_QUOTE_REQUESTED:
      return {
        ...state,
        createQuoteStatus: "requested",
      };
    case CREATE_QUOTE_PENDING:
      return {
        ...state,
        createQuoteStatus: "pending",
      };
    case CREATE_QUOTE_FAILURE:
      return {
        ...state,
        createQuoteStatus: "failure",
      };
    case CREATE_QUOTE_SUCCESS:
      return {
        ...state,
        createQuoteStatus: "success",
      };
    case FETCH_QUOTE_REQUESTED:
      return {
        ...state,
        fetchQuotesStatus: "requested",
      };
    case FETCH_QUOTE_FAILURE:
      return {
        ...state,
        fetchQuotesStatus: "failure",
      };
    case FETCH_QUOTE_SUCCESS:

      payload.filter((quote) => {
        if (quote.status !== "Cancelled") {
          const { serviceprovider } = quote;
          const providers = serviceprovider?.length > 0 ? serviceprovider.filter((provider) => provider.status !== "Declined") : [];

          const newQuote = {
            ...quote,
            serviceprovider: providers,
          };

          newPayload.push(newQuote);

          return true;
        }

        return false;
      });

      return {
        ...state,
        fetchQuotesStatus: "success",
        quotes: newPayload,
      };
    case FETCH_SINGLE_QUOTE_BY_ID_REQUESTED:
      return {
        ...state,
        fetchQuoteByIdStatus: "requested",
      };
    case FETCH_SINGLE_QUOTE_BY_ID_FAILURE:
      return {
        ...state,
        fetchQuoteByIdStatus: "failure",
      };
    case FETCH_SINGLE_QUOTE_BY_ID_SUCCESS:
      return {
        ...state,
        fetchQuoteByIdStatus: "success",
        quotes: [...state.quotes, payload],
      };
    case UPDATE_QUOTE_REQUESTED:
      return {
        ...state,
        updateQuoteStatus: "requested",
      };
    case UPDATE_QUOTE_PENDING:
      return {
        ...state,
        updateQuoteStatus: "pending",
      };
    case UPDATE_QUOTE_FAILURE:
      return {
        ...state,
        updateQuoteStatus: "failure",
      };
    case UPDATE_QUOTE_SUCCESS:
    {
      const quoteList = cloneDeep(state.quotes);
      const quoteIndex = quoteList.findIndex((quote) => quote.identifier === payload.identifier);

      if (quoteIndex > -1) {
        quoteList[quoteIndex] = payload;
      }

      return {
        ...state,
        updateQuoteStatus: "success",
        quotes: quoteList,
      };
    }
    case FETCH_QUOTE_BY_USER_ID_FAILURE: {
      return {
        ...state,
        fetchQuoteByUserIdStatus: "failure",
      };
    }
    case FETCH_QUOTE_BY_USER_ID_SUCCESS: {
      return {
        ...state,
        fetchQuoteByUserIdStatus: "success",
        userQuotes: payload,
      };
    }
    case FETCH_QUOTE_BY_USER_ID_REQUESTED: {
      return {
        ...state,
        fetchQuoteByUserIdStatus: "requested",
      };
    }
    default:
      return state;
  }
}
